import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';
import { getNewsById, isMicroCMSConfigured } from '../lib/microcms';
import { News } from '../types/news';

export const NewsDetailPage = () => {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState<News | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  usePageMeta({
    title: newsItem?.title ?? 'News',
    description: newsItem?.content ? `${newsItem.title}のお知らせを掲載しています。` : 'WAOUHのお知らせです。',
    path: id ? `/news/${id}` : '/news',
  });

  useEffect(() => {
    const run = async () => {
      if (!id) {
        setError('お知らせIDが不正です。');
        setLoading(false);
        return;
      }

      try {
        const data = await getNewsById(id);
        setNewsItem(data);
      } catch (e) {
        setError('お知らせの取得に失敗しました。');
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [id]);

  if (!isMicroCMSConfigured) {
    return (
      <section>
        <p className="notice">microCMSの設定をご確認ください。</p>
        <Link to="/news" className="read-more">
          お知らせ一覧へ戻る
        </Link>
      </section>
    );
  }

  if (loading) {
    return <p className="notice">読み込み中です...</p>;
  }

  if (error || !newsItem) {
    return (
      <section>
        <p className="notice notice-error">
          {error ?? 'お知らせが見つかりませんでした。公開状態とエンドポイント名をご確認ください。'}
        </p>
        <Link to="/news" className="read-more">
          お知らせ一覧へ戻る
        </Link>
      </section>
    );
  }

  return (
    <article className="news-detail">
      <p className="meta">{dayjs(newsItem.publishedAt).format('YYYY.MM.DD')}</p>
      <h1>{newsItem.title}</h1>
      {newsItem.thumbnail?.url && (
        <img src={newsItem.thumbnail.url} alt={newsItem.title} className="detail-thumb" />
      )}
      <div dangerouslySetInnerHTML={{ __html: newsItem.content }} className="news-content" />
      <Link to="/news" className="read-more">
        お知らせ一覧へ戻る
      </Link>
    </article>
  );
};
